module.exports = __webpack_public_path__ + "img/高老庄女.b34a8dfa.png";